/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

import Vue from "vue";
import VueRouter from "vue-router";
import { getUserGuid, common, config } from "assets/js/util";

/**
 * 处理路由页面切换时，异步组件加载过渡的处理函数
 * @param {Object} AsyncView 需要加载的组件，如 import('@/components/home/Home.vue')
 * @return {Object} 返回一个promise对象
 */
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require("base/page-loading/page-loading.vue").default,
    // 加载失败时使用的组件

    error: require("base/page-loadfail/page-loadfail.vue").default,
    delay: 200,
    timeout: 50000
  });
  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children);
    }
  });
}

/* 下单 */
const orderIndex = () =>
  lazyLoadView(
    import(/* webpackChunkName: "orderIndex" */ "components/order/index")
  );
const orderInquire = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "orderInquire" */ "components/order/inquire/inquire"
    )
  );
const orderSubmitAudit = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "submitAudit" */ "components/order/submitAudit/submitAudit"
    )
  );
const result = () =>
  lazyLoadView(
    import(/* webpackChunkName: "result" */ "components/result/result")
  );

/* 用户中心 */

const userIndex = () =>
  lazyLoadView(
    import(/* webpackChunkName: "userIndex" */ "components/user/index")
  );
const myInfo = () =>
  lazyLoadView(
    import(/* webpackChunkName: "myInfo" */ "components/user/personCenter/info")
  );
const myPw = () =>
  lazyLoadView(
    import(/* webpackChunkName: "myPw" */ "components/user/personCenter/pw")
  );

const NotFoundComponent = () =>
  lazyLoadView(
    import(/* webpackChunkName: "NotFoundComponent" */ "components/error/404")
  );

// 现货
const spotGoods = () =>
  lazyLoadView(
    import(/* webpackChunkName: "spotGoods" */ "components/goods/goods")
  );
const goodsIndex = () =>
  lazyLoadView(
    import(/* webpackChunkName: "goodsIndex" */ "components/goods/index/index")
  );
const testpage = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "goodsIndex" */ "components/goods/index/testpage"
    )
  );
const goodsDetail = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "goodsDetail" */ "components/goods/detail/detail"
    )
  );
const goodsInfo = () =>
  lazyLoadView(
    import(/* webpackChunkName: "goodsInfo" */ "components/goods/info/info")
  );

// 扑克牌活动
const poker = () =>
  lazyLoadView(
    import(/* webpackChunkName: "poker" */ "components/activities/poker/poker")
  );

// cad
const cad = () =>
  lazyLoadView(import(/* webpackChunkName: "cad" */ "components/cad/cad"));
const cadIndex = () =>
  lazyLoadView(
    import(/* webpackChunkName: "cadIndex" */ "components/cad/index/index")
  );
// bom解析页面
const bomAnalysis = () =>
  lazyLoadView(
    import(/* webpackChunkName: "bomAnalysis" */ "components/bom/index")
  );
const bomList = () =>
  lazyLoadView(
    import(/* webpackChunkName: "bomList" */ "components/bom/bomList/bomList")
  );
const bomSubmit = () =>
  lazyLoadView(
    import(
      /* webpackChunkName: "bomSubmit" */ "components/bom/bomSubmit/bomSubmit"
    )
  );
const testPage = () =>
  lazyLoadView(import(/* webpackChunkName: "test" */ "components/bom/test"));

const compIndex = () =>
  lazyLoadView(
    import(/* webpackChunkName: "compIndex" */ "components/bom/comp/comp")
  );
// cad 设计 3.0版本
const cadOrder = () =>
  lazyLoadView(
    import(/* webpackChunkName: "compIndex" */ "components/cadOrder/index")
  );
// 模具
const mould = () =>
  lazyLoadView(
    import(/* webpackChunkName: "compIndex" */ "components/mould/index")
  );

Vue.use(VueRouter);
const Router = new VueRouter({
  linkActiveClass: "active",
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (to.name !== "rootResult" && savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0
    };
  },
  // process.env.NODE_ENV === 'production' ? '/' : '/kbidmOrder/'
  base: "/",
  routes: [
    {
      path: "/",
      redirect: {
        name: "rootOrderIndex"
      }
    },
    {
      path: "/index",
      component: orderIndex,
      name: "rootOrderIndex",
      redirect: {
        name: "orderInquire"
      },
      meta: {
        keepAlive: false
      },
      children: [
        {
          path: "inquire",
          component: orderInquire,
          name: "orderInquire",
          meta: {
            requiresAuth: false,
            title: "InZ应龙 | 电子电路智慧云工厂",
            keepAlive: false
          }
        },
        {
          path: ":type(PCB|PCBA|BOM)",
          name: "orderInquireType",
          component: orderInquire,
          meta: {
            title:
              "InZ应龙 | 电子电路智慧云工厂",
            keepAlive: false
          }
        }
      ]
    },
    {
      path: "/submitAudit",
      component: orderSubmitAudit,
      name: "orderSubmitAudit"
    },
    {
      path: "/user",
      component: userIndex,
      name: "rootUser",
      children: [
        {
          path: "myInfo",
          component: myInfo,
          name: "userMyInfo"
        },
        {
          path: "myPw",
          component: myPw,
          name: "userMyPw"
        }
      ]
    },
    {
      path: "/result",
      component: result,
      name: "rootResult",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "*",
      component: NotFoundComponent,
      beforeEnter: (to, from, next) => {
        window.location.replace(`${config.domain}/view/404.html`);
        next();
      }
    },
    {
      path: "/cadOrder",
      component: cadOrder,
      name: "cadOrder",
      meta: {
        requiresAuth: true,
        title: "InZ应龙 | 电子电路智慧云工厂"
      }
    },
    {
      path: "/mould",
      component: mould,
      name: "mould",
      meta: {
        requiresAuth: true,
        title: "InZ应龙 | 电子电路智慧云工厂"
      }
    },
    {
      path: "/goods",
      component: spotGoods,
      name: "spotGoods",
      children: [
        {
          path: "index",
          component: goodsIndex,
          name: "index",
          meta: {
            title: "InZ应龙 | 电子电路智慧云工厂"
          }
        },
        {
          path: "testpage",
          component: testpage,
          name: "testpage",
          meta: {
            title:
              "InZ应龙 | 电子电路智慧云工厂"
          }
        },
        {
          path: "detail",
          component: goodsDetail,
          name: "detail",
          meta: {
            title:
              "InZ应龙 | 电子电路智慧云工厂"
          }
        },
        {
          path: "info",
          component: goodsInfo,
          name: "info",
          meta: {
            title: "InZ应龙 | 电子电路智慧云工厂"
          }
        }
      ]
    },
    {
      path: "/poker",
      component: poker,
      name: "poker",
      meta: {
        requiresAuth: true,
        title: "InZ应龙 | 活动"
      }
    },
    {
      path: "/cadIndex",
      component: cad,
      name: "cadIndex",
      meta: {
        requiresAuth: true,
        title:
          "InZ应龙 | 电子电路智慧云工厂"
      }
    },
    {
      path: "/cad",
      component: cadIndex,
      name: "cad",
      meta: {
        requiresAuth: true,
        title: "印制电路板设计_深圳pcb layout设计公司-造物数科"
      }
    },
    {
      path: "/bom",
      component: bomAnalysis,
      name: "bom",
      meta: {
        requiresAuth: true,
        title:
          "InZ应龙 | 电子电路智慧云工厂"
      }
    },
    {
      path: "/bomList",
      component: bomList,
      name: "bomList",
      mete: {
        requiresAuth: true,
        title:
          "InZ应龙 | 电子电路智慧云工厂"
      }
    },
    {
      path: "/bomSubmit",
      component: bomSubmit,
      name: "bomSubmit",
      mete: {
        requiresAuth: true,
        title:
          "InZ应龙 | 电子电路智慧云工厂"
      }
    },
    {
      path: "/testPage",
      component: testPage,
      name: "testPage",
      mete: {
        requiresAuth: true,
        title:
          "InZ应龙 | 电子电路智慧云工厂"
      }
    },
    {
      path: "/compIndex",
      component: compIndex,
      name: "compIndex",
      mete: {
        requiresAuth: true,
        title:
          "InZ应龙 | 电子电路智慧云工厂"
      }
    }
  ]
});

Router.beforeEach((to, form, next) => {
  console.log(to);
  if (to.params.type == "PCB") {
    to.meta.title = "InZ应龙 | 电子电路智慧云工厂";
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute(
        "content",
        "InZ应龙 | 电子电路智慧云工厂"
      );
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        "深圳专业pcb打样厂家,pcba制造厂商,bom齐套公司—造物数科,专注pcb打样,pcba制造,bom齐套等服务,可单独定制设计,良品率高,交货及时."
      );
  } else if (to.params.type == "PCBA") {
    to.meta.title = "InZ应龙 | 电子电路智慧云工厂";
  } else if (to.path == "/cad") {
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", "印制电路板设计,深圳pcb layout设计,深圳pcb layout设计公司");
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        "深圳市造物数字工业科技有限公司是深圳专业pcb layout设计公司,拥有多年印制电路板设计,pcb layout设计经验,可提供印制电路板设计,pcb layout设计等服务."
      );
  } else {
    window.document.title =
      to.meta.title ||
      "InZ应龙 | 电子电路智慧云工厂";
  }
  // console.log(Router.app.$options.store.state.userGuid);
  //  console.log(to.matched);
  //  console.log(Router.app.$options.store.state);
  // let isLogin = Router.app.$options.store.state.authorToken;
  // if (to.matched.some((record) => record.meta.requireLogin)) {
  //   if (!isLogin) {
  //     common.toLogin();
  //     next(false);
  //   }
  // }

  next();
});

export default Router;




// WEBPACK FOOTER //
// ./src/router/index.js